import React, { FC } from 'react';
import { ContentBanner } from '@modernhealth/vital-components';

import { ContentCardProps } from './ContentCard';
import { mapContentLinkToContentBannerProps } from '../helpers/contentLinkNodeToContentBanner';

export const BannerContentCard: FC<ContentCardProps> = ({ links }) => {
    const mappedLink = mapContentLinkToContentBannerProps(links[0]);
    if (!mappedLink) {
        return null;
    }

    return <ContentBanner {...mappedLink} />;
};
